import React, { useState } from 'react';
import customInputIcon from '../assets/custom_input.svg';
import searchIcon from '../assets/search-white.svg';
import { LoadingButton } from './LoadingButton';

const DiveDeeperSection = ({
  isLoadingNode,
  type,
  nodeId,
  header,
  nodeHasChildrenLoaded,
  childrenExpanded,
  setChildrenExpanded,
  getAllDescendants,
  setNodes,
  handleDiveDeeper,
  isMobile,
}) => {
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');

  const handleExpandOrDiveDeeper = (e) => {
    e.stopPropagation();
    if (nodeHasChildrenLoaded) {
      const isCurrentlyExpanded = childrenExpanded[nodeId] || false;
      setChildrenExpanded((prev) => ({
        ...prev,
        [nodeId]: !isCurrentlyExpanded,
      }));

      const descendants = getAllDescendants(nodeId);
      setNodes((nds) =>
        nds.map((n) => {
          if (descendants.includes(n.id)) {
            return {
              ...n,
              hidden: isCurrentlyExpanded,
            };
          }
          return n;
        })
      );
    } else {
      handleDiveDeeper(nodeId, header);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    e.stopPropagation();
    handleDiveDeeper(nodeId, searchQuery);
    setSearchQuery('');
    setShowSearchInput(false);
  };

  if (isLoadingNode) {
    return <LoadingButton />;
  }

  return (
    <>
      {type === 'subtopic' && (
        <>
          {/* Main Button Section */}
          <div
            style={{
              position: 'absolute',
              bottom: isMobile ? '-40px' : '-60px',
              left: '50%',
              transform: 'translateX(-50%)',
              display: 'flex',
              gap: '12px',
              alignItems: 'center',
            }}
          >
            {/* Expand/Collapse or Dive Deeper */}
            <button
              onClick={handleExpandOrDiveDeeper}
              style={{
                background: '#141414',
                border: '1px solid #7CACF8',
                color: '#ccc',
                cursor: 'pointer',
                padding: isMobile ? '4px 8px' : '6px 12px',
                borderRadius: '6px',
                fontSize: isMobile ? '10px' : '12px',
                fontWeight: 600,
                fontFamily: "'Poppins', sans-serif",
                width: isMobile ? '100px' : '120px',
              }}
            >
              {nodeHasChildrenLoaded
                ? childrenExpanded[nodeId]
                  ? 'Hide Children'
                  : 'Show Children'
                : '+ Dive Deeper'}
            </button>

            {/* Circular Custom Search Button */}
            {!nodeHasChildrenLoaded && (
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  setShowSearchInput(!showSearchInput);
                }}
                style={{
                  background: '#141414',
                  border: '1px solid #7CACF8',
                  color: '#7CACF8',
                  cursor: 'pointer',
                  width: isMobile ? '30px' : '36px',
                  height: isMobile ? '30px' : '36px',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src={customInputIcon}
                  alt="Custom Text Input"
                  title="Custom Search"
                  style={{
                    width: isMobile ? '18px' : '22px',
                    height: isMobile ? '18px' : '22px',
                  }}
                />
              </button>
            )}
          </div>

          {/* Custom Search Input */}
          {!nodeHasChildrenLoaded && showSearchInput && (
            <div
              style={{
                position: 'absolute',
                bottom: isMobile ? '-80px' : '-100px',
                left: '50%',
                transform: 'translateX(-50%)',
                display: 'flex',
                gap: '8px',
                alignItems: 'center',
                width: '100%',
                maxWidth: '180px',
              }}
              onClick={(e) => e.stopPropagation()}
            >
              <form
                onSubmit={handleSearch}
                style={{
                  display: 'flex',
                  gap: '4px',
                  width: '100%',
                }}
              >
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Custom search..."
                  style={{
                    flex: 1,
                    background: '#141414',
                    border: '1px solid #7CACF8',
                    borderRadius: '6px',
                    padding: '4px 10px',
                    color: '#fff',
                    fontSize: isMobile ? '10px' : '12px',
                    fontFamily: "'Poppins', sans-serif",
                    minWidth: '0',
                  }}
                />
                <button
                  type="submit"
                  style={{
                    background: '#141414',
                    border: '1px solid #7CACF8',
                    borderRadius: '100%',
                    cursor: 'pointer',
                  }}
                >
                  <img
                    src={searchIcon}
                    alt="Search"
                    style={{
                      width: isMobile ? '18px' : '18px',
                      height: isMobile ? '18px' : '18px',
                    }}
                  />
                </button>
              </form>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default DiveDeeperSection;
